import type { BirthFormData } from '@/pages/experience/types';

const STORAGE_KEY = 'experience_bazi_form_v1';

/** 从 localStorage 读取缓存的命主表单，缺失/脏字段用默认值补齐；无缓存或解析失败返回 null */
export function loadBaziFormCache(): BirthFormData | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed !== 'object' || parsed === null) return null;
    return {
      name: typeof parsed.name === 'string' ? parsed.name : '',
      gender: parsed.gender === 'female' ? 'female' : 'male',
      birthTime: typeof parsed.birthTime === 'string' ? parsed.birthTime : '',
      birthPlace: typeof parsed.birthPlace === 'string' ? parsed.birthPlace : '',
      currentResidence: typeof parsed.currentResidence === 'string' ? parsed.currentResidence : '',
    };
  } catch {
    return null;
  }
}

/** 保存命主表单到 localStorage */
export function saveBaziFormCache(data: BirthFormData): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    // ignore（隐私模式/存储满等场景静默失败）
  }
}

/** 清空缓存（预留，暂不接 UI） */
export function clearBaziFormCache(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
